import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartAnimator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartAnimator";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {FruitsParticles} from "./animationsbits/fruitsparticles/FruitsParticles";
import {LogoAnimationBit} from "./animationsbits/logo/LogoAnimationBit";
import {FruitsBasicBackground} from "./background/FruitsBasicBackground";
import {FruitsBeforeSpinStopPresentationController} from "./beforespinstop/FruitsBeforeSpinStopPresentationController";
import {FruitsBeforeSpinStopRandomFeatureController} from "./beforespinstop/FruitsBeforeSpinStopRandomFeatureController";
import {FruitsBeforeSpinStopRandomFeatureView} from "./beforespinstop/FruitsBeforeSpinStopRandomFeatureView";
import {BigStickySymbolAndBonusView} from "./bigstickysymbol/BigStickySymbolAndBonusView";
import {BigStickySymbolController} from "./bigstickysymbol/BigStickySymbolController";
import {BigStickySymbolView} from "./bigstickysymbol/BigStickySymbolView";
import {FruitsFontConfig} from "./FruitsFontConfig";
import {FruitsGameAssets} from "./FruitsGameAssets";
import {FruitsGameConfig} from "./FruitsGameConfig";
import {FruitsSoundConfig} from "./FruitsSoundConfig";
import {FruitsGameIntroView} from "./intro/FruitsGameIntroView";
import {FruitsReelController} from "./reel/reel/FruitsReelController";
import {FruitsReelPartAnimator} from "./reel/reel/FruitsReelPartAnimator";
import {FruitsReelAreaView} from "./reel/reelarea/FruitsReelAreaView";
import {FruitsReels} from "./reel/reelarea/FruitsReels";
import {FruitsReelAttentionController} from "./reel/reelpresentation/FruitsReelAttentionController";
import {FruitsReelAttentionOverlayView} from "./reel/reelpresentation/FruitsReelAttentionOverlayView";
import {FruitsScatterReelStopPresentation} from "./reelstoppresentation/scatter/FruitsScatterReelStopPresentation";
import {FruitsStickyRespinReelStopPresentation} from "./reelstoppresentation/stickyrespin/FruitsStickyRespinReelStopPresentation";
import {FruitsWildReelStopPresentation} from "./reelstoppresentation/wild/FruitsWildReelStopPresentation";
import {FruitsReelSymbol} from "./reelsymbol/FruitsReelSymbol";
import {FruitsReelSymbolStateCreator} from "./reelsymbol/FruitsReelSymbolStateCreator";
import {PreIntroScreenViewBit} from "./screen/bonusgame/bits/PreIntroScreenViewBit";
import {PreOutroScreenView} from "./screen/bonusgame/bits/PreOutroScreenView";
import {BonusFeatureSymbolLandingController} from "./screen/bonusgame/BonusFeatureSymbolLandingController";
import {BonusOverlayView} from "./screen/bonusgame/BonusOverlayView";
import {BonusGameIntroController} from "./screen/bonusgame/intro/BonusGameIntroController";
import {BonusGameIntroView} from "./screen/bonusgame/intro/BonusGameIntroView";
import {BonusGameOutroController} from "./screen/bonusgame/outro/BonusGameOutroController";
import {BonusGameOutroView} from "./screen/bonusgame/outro/BonusGameOutroView";
import {FruitsBonusGameController} from "./screen/FruitsBonusGameController";
import {FruitsStickyRespinOverlayView} from "./screen/respin/FruitsStickyRespinOverlayView";
import {FruitsParsedGameData} from "./server/data/FruitsParsedGameData";
import {FruitsParsedInitData} from "./server/data/FruitsParsedInitData";
import {FruitsServerDataParser} from "./server/FruitsServerDataParser";
import {SoundHandler} from "./soundhandler/SoundHandler";
import {FruitsSpinController} from "./spin/FruitsSpinController";
import {FruitsBigWinController} from "./winpresentation/bigwin/FruitsBigWinController";
import {FruitsIndividualWPController} from "./winpresentation/individual/FruitsIndividualWPController";
import {FruitsInitialWPController} from "./winpresentation/initial/FruitsInitialWPController";
import {BonusGameZeroBetController} from "./zerobet/BonusGameZeroBetController";
import {StickyRespinZeroBetController} from "./zerobet/StickyRespinZeroBetController";

/**
 * Created by Alican Köker on 2019-03-04.
 */

export class FruitsGameModuleConfig implements IGameModuleConfig {

    public static instance:FruitsGameModuleConfig = new FruitsGameModuleConfig();

    public static background:FruitsBasicBackground;
    public static stickyRespinOverlayView:FruitsStickyRespinOverlayView;
    public static bonusOverlayView:BonusOverlayView;
    public static soundHandler:SoundHandler;
    public static stickyRespinView:BigStickySymbolView;
    public static logoAnimationBit:LogoAnimationBit;
    public static preIntroScreenViewBit:PreIntroScreenViewBit;
    public static bonusGameController:FruitsBonusGameController;
    public static preOutroScreenViewBit:PreOutroScreenView;
    public static particles:FruitsParticles;
    public static stickyAndBonusView:BigStickySymbolAndBonusView;
    public static reelAttentionOverlayView:FruitsReelAttentionOverlayView;
    public static beforeSpinStopRandomFeatureView:FruitsBeforeSpinStopRandomFeatureView;

    //public

    GAME_CONFIG:IGameConfig = FruitsGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = FruitsSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = FruitsFontConfig.getConfig();
    RESOURCES_CONFIG:IResourcesGroupConfig = FruitsGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new FruitsServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => new FruitsParsedInitData(data, <FruitsServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => new FruitsParsedGameData(data, <FruitsServerDataParser>dataParser);

    SPIN_CONTROLLER:() => SpinController = () => new FruitsSpinController();

    REELS:() => Reels = () => new FruitsReels();
    REEL_AREA_VIEW:() => ReelAreaView = () => new FruitsReelAreaView();

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new FruitsReelController(reelId);

    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.
    REEL_PART_ANIMATOR:(reelId:number) => ReelPartAnimator = reelId => {
        return new FruitsReelPartAnimator(reelId);
    };

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):FruitsReelSymbol => {
            return new FruitsReelSymbol(symName, reelId, state);
        });

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => new FruitsReelSymbolStateCreator();

    INTRO_VIEW:(onClickCallback:() => void) => FruitsGameIntroView =
        (onClickCallback:() => void) => new FruitsGameIntroView({
            layer : FruitsGameConfig.instance.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            resourceGroup : ResourcesGroupName.INTRO,
            backgroundTextures : {
                desktop : {landscape : FruitsGameAssets.MAIN_GAME_BACKGROUND_LANDSCAPE},
                mobile : {landscape : FruitsGameAssets.MAIN_GAME_BACKGROUND_PORTRAIT},
            },
            mobileScale : 1.2,
            portraitScale : 1.0,
            featureIcons : {
                icons : [IntroFeatureLogo.VOLATILITY_MEDIUM]
            },
        });

    SCREENS:(() => ScreenController)[] = [
        () => new BonusGameIntroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new BonusGameIntroView({
                    layer : FruitsGameConfig.instance.LAYERS.BONUS_GAME_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.2
                }, autoClose);
            }
        }),
        () => new BonusGameOutroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new BonusGameOutroView({
                    layer : FruitsGameConfig.instance.LAYERS.BONUS_GAME_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.2
                }, autoClose);
            }
        })
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new StickyRespinZeroBetController(),
        () => new BonusGameZeroBetController()
    ];

    BEFORE_SPIN_STOP_PRESENTATIONS?:((index:number) => BeforeSpinStopPresentationController)[] = [
        index => new FruitsBeforeSpinStopPresentationController(index),
        index => new FruitsBeforeSpinStopRandomFeatureController(index)
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [
            indexes => new FruitsBigWinController(indexes),
            indexes => new FruitsInitialWPController(indexes)
        ],
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        index => new FruitsReelAttentionController(index),
        index => new BonusFeatureSymbolLandingController(index),
        index => new FruitsScatterReelStopPresentation(index),
        index => new FruitsWildReelStopPresentation(index),
        index => new FruitsStickyRespinReelStopPresentation(index)
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new FruitsIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0;
            }
        });
    };

    GAME_FEATURE_CREATOR:() => void = () => {
        FruitsGameModuleConfig.background = new FruitsBasicBackground({
            layer : GameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {
                    landscape : {
                        image : FruitsGameAssets.MAIN_GAME_BACKGROUND_LANDSCAPE
                    },
                    portrait : {
                        image : FruitsGameAssets.MAIN_GAME_BACKGROUND_PORTRAIT
                    }
                },
                BONUS : {
                    landscape : {
                        image : FruitsGameAssets.BONUS_GAME_BACKGROUND_LANDSCAPE
                    },
                    portrait : {
                        image : FruitsGameAssets.BONUS_GAME_BACKGROUND_PORTRAIT
                    }
                }
            },
            stretch : false
        });
        FruitsGameModuleConfig.stickyRespinOverlayView = new FruitsStickyRespinOverlayView();
        FruitsGameModuleConfig.bonusOverlayView = new BonusOverlayView();
        FruitsGameModuleConfig.soundHandler = new SoundHandler();
        FruitsGameModuleConfig.stickyRespinView = new BigStickySymbolView();
        FruitsGameModuleConfig.logoAnimationBit = new LogoAnimationBit();
        FruitsGameModuleConfig.preIntroScreenViewBit = new PreIntroScreenViewBit();
        FruitsGameModuleConfig.bonusGameController = new FruitsBonusGameController();
        FruitsGameModuleConfig.preOutroScreenViewBit = new PreOutroScreenView();
        FruitsGameModuleConfig.particles = new FruitsParticles();
        FruitsGameModuleConfig.stickyAndBonusView = new BigStickySymbolAndBonusView();
        FruitsGameModuleConfig.reelAttentionOverlayView = new FruitsReelAttentionOverlayView();
        FruitsGameModuleConfig.beforeSpinStopRandomFeatureView = new FruitsBeforeSpinStopRandomFeatureView();
        new BigStickySymbolController();

        /*FruitsGameModuleConfig.betLinesView = new BetLinesView(
            {
                map : [
                    4, 2, 6, 8, 1, 10, 9, 7, 3, 5, // left
                    12, 18, 20, 16, 11, 14, 15, 17, 13, 19 // right
                ]
            },
            (index:number):TextBetLineNumber => {
                return new TextBetLineNumber(index, {
                    layer : GameConfig.instance.LAYERS.BET_LINES.name,
                    width : 40,
                    height : 40,
                    horizontalPadding : GameConfig.instance.REEL_AREA_POS_X - 25,
                    verticalPadding : [
                        GameConfig.instance.REEL_AREA_POS_Y + 40,
                        (GameConfig.instance.GAME_HEIGHT - (GameConfig.instance.REEL_AREA_POS_Y + GameConfig.instance.REEL_AREA_HEIGHT)) + 40
                    ],
                    textStyleNormal : {
                        fontFamily : "Open Sans",
                        fontSize : 20,
                        fill : "#a6759a"
                    },
                    textStyleWin : {
                        fontFamily : "Open Sans",
                        fontSize : 30,
                        fill : "#ffffff",
                        stroke : "#dfb8cd",
                        strokeThickness : 2,
                        padding : 4

                    },
                    textWinScale : 1
                });
            },
            (index:number, numberPosition:number[], betLineData:number[]):PolyBetLine => {
                return new PolyBetLine(index, numberPosition, betLineData, {
                    staticLineLayer : GameConfig.instance.LAYERS.BET_LINES.name,
                    styles : [
                        {
                            "lineWidth" : 3,
                            "color" : 0xffffff,
                            "alpha" : 1
                        },
                        {
                            "lineWidth" : 1,
                            "color" : 0xdfb8cd,
                            "alpha" : 1
                        }
                    ],
                    numberOffsetX : 20,
                    pointOverlapVerticalOffset : 8
                });
            }
        );
*/

        /*FruitsGameModuleConfig.reelBackground = new FruitsReelBackground({
            layer : FruitsGameConfig.instance.LAYERS.REEL_BACKGROUND.name,
            backgroundImages : {
                NORMAL : {
                    image : FruitsGameAssets.REEL_FRAME, offset : new PIXI.Point(-480, -480)

                },
                FREESPIN : {
                    image : FruitsGameAssets.REEL_FRAME, offset : new PIXI.Point(-480, -480)

                },
            },
            stretch : false
        });*/

        StageManager.legacyScaling = true;
    };

    constructor() {
        if(FruitsGameModuleConfig.instance) {
            throw new Error("FruitsGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}